import en from "config/strings/en"
import dayjs from "dayjs"
import { validateEmail, validateIsraeliId, validateIsraeliIdOrPassport, validatePhoneNumber } from "utils/validation"

const validate = (testTaker) => {
    const errors = {}

    if (testTaker) {
        const { parent_phone, parent_email, parent_first_name, language, gender, first_name, last_name, dob, tz, home_class, home_affiliation, home_grade } = testTaker

        if (!first_name)
            errors.first_name = en.required
        if (!last_name)
            errors.last_name = en.required
        if (!dob) {
            errors.dob = en.require2
        }
        else if (new Date().getFullYear() - new Date(dayjs(dob)).getFullYear() < 3)
            errors.dob = en.minAge

        // if (!school && !affiliation)
        //     errors.school = en.required
        if (!home_affiliation)
            errors.home_affiliation = en.required

        if (!home_grade)
            errors.home_grade = en.required
        if (!home_class)
            errors.home_class = en.required

        if (!testTaker.tz)
            errors.tz = en.require('tz')
        else if (!validateIsraeliId(testTaker.tz))
            errors.tz = en.invalidTZ

        if (!gender)
            errors.gender = en.required

        if (!language)
            errors.language = en.require2

        if (!parent_first_name)
            errors.parent_first_name = en.require2

        if (!parent_email && !parent_phone) {
            errors.parent_email = en.require2
            errors.parent_phone = en.require2
        }
        else {
            if (parent_phone) {
                const phoneValidation = validatePhoneNumber(parent_phone)
                if (!phoneValidation) {
                    // הסרת מקפים ורווחים לבדיקה
                    const cleanPhone = parent_phone.replace(/[\-\s]/g, '')
                    // בדיקה שמתחיל ב-05 או 07 ויש לו בדיוק 10 ספרות
                    if (!/^(05|07)[0-9]{8}$/.test(cleanPhone)) {
                        errors.parent_phone = en.invalidPhone // או הודעה מותאמת
                    }
                } else {
                    errors.parent_phone = phoneValidation
                }
            }
            if (parent_email) {
                const emailValidation = validateEmail(parent_email)
                if (emailValidation)
                    errors.parent_email = emailValidation
            }
        }
    }

    return errors;
}

export default validate
